


























import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { ResultSortCriteria, ScoreCriteriaDetail } from '@empathybroker/tsclient-search';

import { ColorEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import { ExplainScoreCriteriaMessages } from '../../models';

import { ExplainUtils } from '../../utils';

import Badge from '../badge.component.vue';

export default {
  name: 'explain-result-overlay',
  props: {
    result: {
      type: Object,
      required: true
    },
    hovered: Boolean,
    selected: Boolean,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge
  },
  computed: {
    mainSortCriteria: function (): ResultSortCriteria {
      if (!!this.result.debug.sort.length) {
        return this.result.debug.sort[0];
      }
    },
    sortValueText: function (): string {
      if (!!this.mainSortCriteria) {
        let sortValue = this.mainSortCriteria.value;
        if (!isNaN(Number(sortValue))) {
          sortValue = Number(sortValue);
        }
        return sortValue.toLocaleString(this.$epb.locale);
      }
    },
    scoreCriteriaDetailTypes: function (): (ScoreCriteriaDetailTypeEnum | string)[] {
      const scoreCriteriaDetailTypes = [];
      const resultScoreCriteria = ExplainUtils.getResultScoreCriteria(this.result);
      if (!!resultScoreCriteria) {
        Object.entries(resultScoreCriteria.details)
          .forEach(([criteriaDetailType, criteriaDetail]: [ScoreCriteriaDetailTypeEnum, ScoreCriteriaDetail]) => {
            if ((criteriaDetailType !== ScoreCriteriaDetailTypeEnum.CATALOG_DEFINITION) && !!criteriaDetail.value) {
              scoreCriteriaDetailTypes.push(criteriaDetailType);
            }
          });
      }
      return scoreCriteriaDetailTypes;
    },
    businessRulesCriteriaDetailAction: function (): RankingActionEnum {
      return (this.mainSortCriteria.details[ScoreCriteriaDetailTypeEnum.BUSINESS_RULES].value > 0) ?
        RankingActionEnum.BOOST : RankingActionEnum.BURY;
    }
  },
  data: function () {
    return {
      ColorEnum
    };
  },
  methods: {
    getScoreCriteriaDetailBadgeColor: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): ColorEnum {
      if (criteriaDetailType === ScoreCriteriaDetailTypeEnum.BUSINESS_RULES) {
        return (this.businessRulesCriteriaDetailAction === RankingActionEnum.BOOST) ? ColorEnum.GREEN : ColorEnum.RED;
      }
      return ColorEnum.LIGHT_GREY;
    },
    getScoreCriteriaDetailLabel: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      return this.getScoreCriteriaDetailMessages(criteriaDetailType).label;
    },
    getScoreCriteriaDetailMessages: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(criteriaDetailType, this.messages.score);
    },
    getScoreCriteriaDetailIconClasses: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string[] {
      const classes = [];
      if (!!this.getScoreCriteriaDetailIcon(criteriaDetailType)) {
        classes.push('eicon');
      }
      if (criteriaDetailType === ScoreCriteriaDetailTypeEnum.BUSINESS_RULES) {
        classes.push(`epb-explain-result-overlay__icon--${ this.businessRulesCriteriaDetailAction.toLowerCase() }`);
      }
      return classes;
    },
    getScoreCriteriaDetailIcon: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      if (criteriaDetailType === ScoreCriteriaDetailTypeEnum.BUSINESS_RULES) {
        return 'arrowdownward';
      }
      return ExplainUtils.getResultScoreCriteriaDetailIcon(criteriaDetailType);
    },
    getScoreCriteriaDetailIconAlt: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      return this.getScoreCriteriaDetailMessages(criteriaDetailType).abbr.substring(0, 1);
    }
  }
};

